<template>
  <el-dialog @closed="clearTable" :title="title" append-to-body :visible.sync="dialogVisible" :close-on-click-modal="false" width="976px">
      <div style="height: 100%;" class="clearfix">
        <el-input suffix-icon="el-icon-search" @keyup.enter.native="getPrj" @blur="getPrj" @clear="getPrj" class="fr" style="width: 265px;margin-bottom: 10px;" clearable placeholder="输入关键字进行过滤" size="small" v-model="filterText"> </el-input>
        <el-table :data="tableData" v-loading="dataListLoading" @selection-change="selectionChangeHandle" :height="466" style="width: 100%;">
          <el-table-column :selectable="selectable" type="selection" header-align="center" align="center" width="50"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="prodName" label="产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="tiName" label="检测项目名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="funStdCode" label="检测方法"></el-table-column>
          <el-table-column show-overflow-tooltip prop="funstdClauseCode" width="70" label="条款号"></el-table-column>
          <el-table-column show-overflow-tooltip prop="funstdClauseName" width="140" label="条款名"></el-table-column>
          <el-table-column show-overflow-tooltip prop="stdCode" label="判定依据"></el-table-column>
          <el-table-column show-overflow-tooltip prop="usingRange" label="使用范围"></el-table-column>
        </el-table>
        <div v-if="tableData.length > 0" class="mod-page">
          <pagination v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex" :limit.sync="pageLimt"
            @pagination="getPrj" />
        </div>
      </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :disabled="!dataListSelections.length" @click="setPrj">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      title: '',
      dialogVisible: false,
      dataListLoading: false,
      dataListSelections: [],
      tableData: [],
      orderId: "",
      currGoods: "",
      pageIndex: 1,
      pageLimt: 10,
      totalPage: 0,
      selectFiter:[],
      filterText:''
    };
  },
  methods: {
    setPrj(){
      this.$emit("addPrj",this.dataListSelections);
    },
    selectable(row){
      return !this.selectFiter.includes(row.projectId);
    },
    clearTable(){
      this.tableData = [];
    },
    init(orderId, type,selectFiter,sample) {
      this.filterText = '';
      this.currGoods = sample.goodsPrn || sample.objId;
      this.orderId = orderId;
      this.title = type==2 ? '选择添加样品' : '添加检项';
      this.tableInfo = {};
      this.dataListSelections = [];
      this.dialogVisible = true;
      // 获取检项
      this.getPrj();
      // 已勾选检项
      this.selectFiter = selectFiter;
    },
    getPrj(p) {
      this.dataListLoading = true;
      if(!p || !p.page){
        this.pageIndex = 1;
      }
      let param = {
        current: this.pageIndex,
        size: this.pageLimt,
        data: {
          // prodPrn: this.currGoods,
          st: 1,
          search:this.filterText
        }
      }
      this.$http.post(this.$api.goodsApi.getPrjByProd, param).then(({ data }) => {
        this.dataListLoading = false;
        this.tableData = data.data.list || [];
        this.totalPage = data.data.total;
      }).catch(()=>{
        this.dataListLoading = false;
      });
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog div.el-dialog__body {
  height: calc(100% - 146px);
}
::v-deep .el-dialog__footer{
  margin-top: 0;
  .el-button {
  width: 80px;
  line-height: 38px;
  border-radius: 20px;
  font-size: 14px;
  .el-loading-mask{
    border-radius: 20px;
  }
}
}
::v-deep .mod-page .pagination-container{
  padding:0;
  padding-top: 16px;
}
::v-deep .el-table td.el-table__cell{
    border-bottom: 1px solid #ebebeb;
    border-right: 1px solid #ebebeb;
}
</style>
